module.exports = __webpack_public_path__ + "fallback-product-image.png";